import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User changed the default Meta ad account',
  name: 'meta_default_account_changed',
};

export default META;
